<!-- Ссылки на управление доступом к данным компании. -->
<template>
  <SettingSection
    title="Доступ"
    icon-variant="access"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";

export default {
  name: "AccessSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <circle cx="18" cy="5" r="3"></circle>
        <circle cx="6" cy="12" r="3"></circle>
        <circle cx="18" cy="19" r="3"></circle>
        <path d="m8.6 10.6 6.8-4.2"></path>
        <path d="m8.6 13.4 6.8 4.2"></path>
      `,
      links: [
        {
          label: "Общий доступ",
          route: { name: "Sharings" },
        },
      ],
    };
  },
};
</script>
